// removed by extract-text-webpack-plugin
module.exports = {"container":"_16lo","light":"_3x9C","gray":"_1VTF","wrapper":"_2euX","primaryColor":"_1TS1","description":"_1taI"};


//////////////////
// WEBPACK FOOTER
// ./src/components/WorkAtSaits/styles.scss
// module id = 391
// module chunks = 0